import * as React from 'react';
import { FormPadButtonRadio, PadButtonGroup } from 'omakase';
import {
  IconChampagne,
  IconDelivery,
  IconPlate,
  IconTableSeating,
  IconTicket,
  IconToGo,
} from '@tock/icons/dist';
import { IllustrationColor } from 'ui/illustrations/Illustration';
import { OFFERING_TYPE_HEADER_ID } from 'components/www/availability-search/filters/SearchFiltersDialog';
import {
  SearchFiltersFieldNames,
  SearchFiltersFields,
} from 'components/www/availability-search/SearchHeader';
import { css } from '@emotion/react';

const iconMap: Record<string, React.FC<{ color: 'primary' | 'inherit' }>> = {
  ALL_EXPERIENCES: IconPlate,
  DINE_IN_EXPERIENCES: IconTableSeating,
  ORDER_PICKUP: IconToGo,
  ORDER_DELIVERY: IconDelivery,
  EVENT: IconTicket,
  WINERY: IconChampagne,
};

const mapIllustrationColorToIconColor = (color: IllustrationColor): 'primary' | 'inherit' => {
  return color === 'primary' ? 'primary' : 'inherit';
};

const Illustration: React.FC<{ type: string; color: IllustrationColor }> = ({ type, color }) => {
  const IconComponent = iconMap[type] || IconPlate;
  return <IconComponent color={mapIllustrationColorToIconColor(color)} />;
};

interface SearchFilterTypeProps {
  values: SearchFiltersFields;
}

const SearchFilterType: React.FunctionComponent<SearchFilterTypeProps> = ({ values: { type } }) => {
  const getIllustrationColor = (value: string, selected: string | undefined): IllustrationColor => {
    return selected === value ? 'primary' : 'dark';
  };

  const options: { value: string; displayName: string }[] = [
    { value: 'ALL_EXPERIENCES', displayName: 'Everything' },
    { value: 'DINE_IN_EXPERIENCES', displayName: 'Dine in' },
    { value: 'ORDER_PICKUP', displayName: 'Pickup' },
    { value: 'ORDER_DELIVERY', displayName: 'Delivery' },
    { value: 'EVENT', displayName: 'Events' },
    { value: 'WINERY', displayName: 'Wineries' },
  ];

  const renderPadButton = (value: string, displayValue: string) => (
    <FormPadButtonRadio
      value={value}
      key={value}
      decorativeElement={<Illustration type={value} color={getIllustrationColor(value, type)} />}
      name={SearchFiltersFieldNames.type}
      variant="basic"
      label={displayValue}
    />
  );

  return (
    <PadButtonGroup
      css={css`
        svg {
          margin-bottom: 10px;
          width: 35px;
          height: 35px;
        }
      `}
      background={false}
      numColumns={3}
      columnGap={1}
      aria-labelledby={OFFERING_TYPE_HEADER_ID}
    >
      {options.map(({ value, displayName }) => renderPadButton(value, displayName))}
    </PadButtonGroup>
  );
};

export default SearchFilterType;
